module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Mute-40621a7218a551725483711f26b65359e91e24d7aba362f38b25e848b2343be9.svg";